import { JobProfileForm } from './JobProfileForm';

export function CreateJobProfile() {
  return <JobProfileForm />;
}